import { BaseCategory } from "./BaseCategory";
import { ElementTextBlockPositionType, HorizontalAlignType, PositionType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class BiographyCategory extends BaseCategory {
    get name() {
        return "Biography";
    }

    get type() {
        return SlideCategories.BIOGRAPHY;
    }

    get icon() {
        return null;
    }

    get description() {
        return "Use for presenting biographical information about a person, including their background, accomplishments, and relevant details with a photo.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Create a biography slide for the person mentioned in the user's prompt.
        Provide the person's name and a biographical description.
        Suggest a search term for finding an appropriate photo of the person.`;
    }

    getPromptSchema() {
        return {
            personName: "the name of the person",
            biographyText: "richtext biography or description of the person (do not include the person's name here)",
            photoSearch: "search term for finding a photo of the person (e.g., 'person name portrait', 'person name headshot')",
        };
    }

    getImagePrompt() {
        return super.getImagePrompt();
    }

    getSlideModels(model) {
        let models = [
            this.buildBiographySlide(model),
        ];

        return models;
    }

    buildBiographySlide(model) {
        let builder = new SlideModelBuilder("headline2", model);

        if (model.biographyText) {
            for (let block of model.biographyText) {
                if (block.textStyle === TextStyleType.HEADING) {
                    block.textStyle = TextStyleType.TITLE;
                }
                if (block.textStyle === TextStyleType.BULLET_LIST) {
                    block.indent = (block.indent ?? 0) + 1;
                }
            }
        }

        let primary = {
            fullBleed: true,
            showGutter: true,
            headlinePosition: PositionType.RIGHT,
            textPosition: PositionType.LEFT,
            textAlign: HorizontalAlignType.LEFT,
            text: {
                blocks: [
                    builder.createBlock(model.personName, TextStyleType.HEADING),
                    ...model.biographyText || []
                ]
            },
        };

        // Add image on the left
        const imagePrompt = model.slideImage?.prompt || model.photoSearch || `${model.personName} portrait`;
        primary.items = [{
            componentType: "TextAndImage",
            childElement: builder.createImage(imagePrompt, {}, !!model.slideImage?.prompt)
        }];

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.INLINE);
        }

        return builder.model;
    }
}
